import login from "../pages/login";
import { getFileName } from "./helper";

// excel 파일 다운로드 반환 함수
export const excelDownloadHelper = (file) => {
  let blob = new Blob([file.data], {
    type: file.headers["content-type"],
    encoding: "UTF-8",
  });

  // 파일명 디코딩
  let name = decodeURI(file.headers["content-disposition"]);

  if (window.navigator.msSaveOrOpenBlob) {
    // IE 10+는 해당 함수 제공
    window.navigator.msSaveOrOpenBlob(blob);
  } else {
    let link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.target = "_self";
    if (name) link.download = name.split("=")[1];
    link.click();
    window.URL.revokeObjectURL(link); //메모리 누수 방지
  }
};

// pdf 파일 다운로드 반환 함수
export const pdfDownloadHelper = (file) => {
  let blob = new Blob([file.data], {
    type: file.headers["content-type"],
    encoding: "UTF-8",
  });

  // 파일명 디코딩
  let name = decodeURI(file.headers["content-disposition"]);
  // fileName = getFileName(name);

  if (window.navigator.msSaveOrOpenBlob) {
    // IE 10+는 해당 함수 제공
    window.navigator.msSaveOrOpenBlob(blob);
  } else {
    let link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.target = "_self";
    if (name) link.download = name.split(`"`)[1];

    link.click();
    window.URL.revokeObjectURL(link); //메모리 누수 방지
  }
};

// 파일 다운로드 반환 함수
export const fileDownloadHelper = (fileUrl) => {
  let fileName = getFileName(fileUrl);

  const a = document.createElement("a");
  a.href = fileUrl;
  a.download = fileName;
  a.target = "_blank";
  a.click();
};
